<template>
    <b-overlay :show="submitting || generalDeleting || loading" rounded="sm">
    <b-card-body style="background: #fff">
        <div class="d-flex title-bar-block mb-2">
            <div class="icon-block me-4">
                <button id="cancel-label-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ $translate('select_items') }}</span>
            </div>
        </div>
        <b-tabs card align="center">
                <b-tab :title="title" active class="p-0 mt-3">
                    <p>
                        <label style="font-weight: bold">{{ $translate('total_quantity') }}</label>&nbsp;{{ totalQty }}
                    </p>
                    <b-card-text>
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-row class="filter-form p-0">
                                <b-col v-for="(d_item, i) in validDataItems" :key="i + 'data'" :class="d_item.label" :cols="d_item.cols" md="6">
                                    <b-col cols="12" :class="{
                                        'd-flex flex-row-reverse justify-content-end gap-2 align-items-center':
                                            d_item.type === 'boolean',
                                        'mt-3': i !== 0,
                                    }">
                                        <label :id="d_item.field" :class="{
                                            'mb-3': d_item.type !== 'boolean',
                                            dd: d_item.type === 'select',
                                        }" :for="'input-' + d_item.field"><strong>{{
        $translate(d_item.label)
    }}</strong><span class="red">{{
        d_item.required ? '*' : ''
    }}</span></label>
                                        <!-- <h3>{{ d_item.field }}</h3> -->
                                        <!-- <h1>{{ d_item }} : {{ d_item.cols }}</h1> -->
                                        <!-- <h1 v-if="d_item.field === 'description'">
                                            {{ d_item }} : {{ model[d_item.field] }} {{ d_item.cols }}
                                        </h1> -->
                                        <master-item-type-ahead v-if="d_item.field === 'container_id'"
                                            v-model="model[d_item.field]" :is-product-only="true"
                                            :disabled="isView"></master-item-type-ahead>
                                        <selection-values v-else-if="d_item.field === 'value_selections'
                                            " :id="'input-' + d_item.field" v-model="model[d_item.field]"
                                            :required="d_item.required" :name="'input-' + d_item.field" :disabled="isView">
                                        </selection-values>

                                        <default-value v-else-if="d_item.field === 'default_value'
                                            " :is-selection-value-type="!!model.is_selection_value_type
            " :values="model.value_selections" :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]" :required="d_item.required" :disabled="isView"
                                            :min="parseInt(model.value_min)" :max="parseInt(model.value_max)" />

                                        <div class="form-check me-2" v-else-if="d_item.type === 'boolean'">
                                            <label class="form-check-label">
                                                <input type="checkbox" :id="'input-' + d_item.field"
                                                    v-model="model[d_item.field]" :required="d_item.required"
                                                    :name="'input-' + d_item.field" :value="1" :unchecked-value="0"
                                                    :disabled="isView" />
                                                <i class="input-helper"></i>
                                            </label>
                                        </div>
                                        <b-form-select class="form-control" v-else-if="d_item.type === 'select'"
                                            :id="'input-' + d_item.field" v-model="model[d_item.field]"
                                            :required="d_item.required" :options="getOptions(d_item.field)" :disabled="isView">
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>{{
                                                    $translate('select') + ' ' + $translate(d_item.label)
                                                }}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                        <b-form-input v-else :disabled="isView" :type="d_item.type"
                                            :id="'input-' + d_item.field" v-model="model[d_item.field]"
                                            :required="d_item.required" :placeholder="$translate('enter') + ' ' + $translate(d_item.label)
                                                " trim>
                                        </b-form-input>
                                        <!-- <h3 v-if="d_item.field === 'description'">
                                            {{ $translate(d_item.label) }}: {{ model[d_item.field] }}
                                        </h3> -->
                                    </b-col>
                                </b-col>
                                <b-col cols="12" class="mt-3">
                                    <label class="mb-3"><strong>{{$translate('attachments')  }} </strong></label>
                                  <view-attachments :view-mode="isView" :is-new="!!model.id" />
                                </b-col>
                            </b-row>

                            <b-form-row>
                                <b-col class="text-center my-3">
                                    <b-button id="view-master-item-btn" class="me-2" v-if="!!model.id && hasPermissionUpdate" variant="info" size="fw"
                                        :disabled="!!submitting" @click="isView = !isView">{{ isView ? $translate('edit') :
                                            $translate('view') }}</b-button>
                                    <b-button id="create-master-item-btn" v-if="!model.id && hasPermissionCreate" variant="info" size="fw" class="me-2"
                                        :disabled="!!submitting" type="submit">
                                        {{ !!submitting ? $translate('creating') : $createLabel() }}
                                    </b-button>

                                    <b-button id="update-master-item-btn" variant="info" size="fw" class="me-2" v-if="!!model.id &&
                                        hasPermissionUpdate &&
                                        !isView
                                        " :disabled="!!submitting" type="submit">
                                        {{ !!submitting ? $translate('updating') : $updateLabel() }}
                                    </b-button>

                                    <b-button id="delete-master-item-btn" class="me-2" size="fw" v-if="!!model.id &&
                                        hasPermissionDelete &&
                                        isView
                                        " @click="deleteMasterItem()" variant="delete-button">
                                        {{ $deleteLabel() }}
                                    </b-button>
                                    <b-button id="cancel-master-item-btn" variant="info" size="fw" :disabled="!!submitting"
                                        @click="cancel()">{{ $cancelLabel() }}</b-button>
                                </b-col>
                            </b-form-row>
                        </b-form>
                    </b-card-text>
                </b-tab>
                <b-tab :title="$translate('inventory')" class="p-0">
                    <b-card-body class="p-0 mt-3">
                        <ItemInventory :total-qty="totalQty" :inventory-list="inventoryList" />
                    </b-card-body>
                </b-tab>
                <b-tab :title="$translate('transactions')" class="p-0">
                    <b-card-body class="p-0 mt-3">
                        <item-transactions :total-qty="totalQty" />
                    </b-card-body>
                </b-tab>
        </b-tabs>
    </b-card-body>
    </b-overlay>
</template>
<script>
const dataItems = [
    { field: 'name', label: 'name', type: 'text', required: true, cols: '12' },
    {
        field: 'ext_reference_code',
        label: 'ref_code',
        type: 'text',
        required: true,
        cols: '12',
    },
    {
        field: 'external_reference_code',
        label: 'ext_ref_code',
        type: 'text',
        required: false,
        cols: '12',
    },
    {
        field: 'order_item_type_id',
        label: 'type',
        type: 'select',
        required: true,
        cols: '12',
    },
   
    
    {
        field: 'container_id',
        label: 'bundled_with',
        type: 'custom',
        required: false,
        cols: '12',
    },
    {
        field: 'size',
        label: 'size',
        type: 'number',
        required: false,
        cols: '12',
    },
    { field: 'description', label: 'description', type: 'text', required: true, cols: '12' },
    { field: 'vendor_id', label: 'vendor', type: 'select', required: true, cols: '12' },
    { field: 'uom', label: 'uom', type: 'select', required: true, cols: '12' },
    {
        field: 'selling_price',
        label: 'selling_price',
        type: 'number',
        required: false,
        cols: '12',
    },
    {
        field: 'default_rental_rate',
        label: 'default_rental_rate',
        type: 'number',
        required: false,
        cols: '12',
    },

    {
        field: 'is_selection_value_type',
        label: 'is_selection_value_type',
        type: 'boolean',
        required: false,
        cols: '12',
    },

    { field: 'value_name', label: 'value_name', type: 'text', required: false, cols: '12' },
    { field: 'value_max', label: 'value_max', type: 'number', required: false, cols: '12' },
    { field: 'value_min', label: 'value_min', type: 'number', required: false, cols: '12' },
    { field: 'value_selections', label: 'value_selections', type: 'custom', required: false, cols: '12' },
    { field: 'default_value', label: 'default_value', type: 'custom', required: false, cols: '12' },
    { field: 'active', label: 'active', type: 'boolean', required: false, cols: '12' },
]

const generateEmptyForm = () => {
    return dataItems.reduce(
        (_form, item) => {
            _form[item.field] = null
            return _form
        },
        { id: 0 }
    )
}

import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import SelectionValues from './SelectionValues.vue'
import DefaultValue from './DefaultValue.vue'
import ItemInventory from './ItemInventory.vue'
import ItemTransactions from '../../components/ItemTransactions.vue'
import MasterItemTypeAhead from '@/components/MasterItemTypeAhead'
import ViewAttachments from "./ViewAttachments.vue";
const model = generateEmptyForm()
export default {
    name: 'MasterItems-viewItem',
    components: {
        SelectionValues,
        DefaultValue,
        ItemInventory,
        MasterItemTypeAhead,
        ItemTransactions,
        ViewAttachments
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    props: ['id'],
    data() {
        return {
            dataItems,
            model,
            submitting: false,
            hasErrors: false,
            isView: false,
            loading: false,
        }
    },

    computed: {
        componentName() { return this.$translate('master_item') },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        selectionOptions() {
            const { value_selections } = this.model
            try {
                return JSON.parse(value_selections)
            } catch (err) {
                return []
            }
        },
        title() {
            return this.isView
                ? this.$translate('selected_item')
                : this.id
                    ? this.$translate('edit_item')
                    : this.$translate('add_item')
        },
        /*   item() {
            return this.$store.state.masterItem.item
        },
 */
        vendors() {
            return this.$store.state.assets.vendors
        },

        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },
        unitMeasures() {
            return this.$store.state.masterItem.unit_of_measures && this.$store.state.masterItem.unit_of_measures.map(x => ({id: x.name ,...x}))
        },

        is_product() {
            const { order_item_type_id } = this.model
            return !(this.types.find(x => x.id === order_item_type_id) || {})
                .is_task
        },
        is_task() {
            const { order_item_type_id } = this.model
            return (this.types.find(x => x.id === order_item_type_id) || {})
                .is_task
        },
        validDataItems() {
            const { is_product, is_task } = this
            const { is_selection_value_type } = this.model
            return this.dataItems.filter((x) => {
                if(x.field === 'container_id') return is_product 
                if(x.field === 'selling_price') return !is_task
                if(x.field === 'value_selections') return is_selection_value_type 
                if(x.field === 'value_min' || x.field === 'value_max') return !is_selection_value_type 
                return true
            })
        },
        totalQty() {
            return this.inventoryList.reduce((_sum, item) => {
                _sum += item.quantity_on_hand
                return _sum
            }, 0)
        },
        inventoryList() {
            return this.$store.getters['masterItem/sections'].filter(
                ({ location_section: x }) =>
                    x.officers.length || x.location.is_warehouse
            )
        },
        assetAttachments() {
            return this.$store.state.masterItemAttachmentsStore.attachments
         },
    },
    watch: {
        'model.order_item_type_id': function (id) {
            const type = this.types.find(x => x.id === id)
            console.log('type', type)
            if (type) model.uom = type.uom
        },
    },
    created() {
        this.isView = !!this.id
    },
    async mounted() {
        this.loading = true
        const { id } = this
        console.log('id', id)
        this.model = generateEmptyForm()
        if (id) {
            this.loadMasterItem(id)
            await this.$store.dispatch("masterItem/fetchAttachments",id);
            // this.$store.dispatch('masterItem/fetchById', id)
        }
        this.loading = false
    },
    methods: {
        async loadMasterItem(id) {
            this.loading = true
            this.isView = true
            try {
                const _item = await this.$store.dispatch(
                    'masterItem/fetchByIdFunction',
                    id
                )
                for (const key in this.model) {
                    this.$set(this.model, key, _item[key])
                }
                const value_selections = _item.value_selections
                    ? JSON.parse(_item.value_selections)
                    : []

                this.$set(this.model, 'value_selections', value_selections)
            } catch (error) {
                console.error(error)
                this.isError = true
            } finally {
                this.loading = false
            }
        },

        checkVisibility(item) {
            switch (item.field) {
                case 'value_selections':
                    return !!this.model.is_selection_value_type
                case 'value_min':
                case 'value_max':
                    return !this.model.is_selection_value_type
                default:
                    return true
            }
        },
        getOptions(data) {
            const arr = (() => {
                switch (data) {
                    case 'vendor_id':
                        return this.vendors || []
                    case 'order_item_type_id':
                        return this.types || []
                    case 'uom':
                        return this.unitMeasures || []
                }
            })()

            return arr.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        cancel() {
            this.$store.commit("masterItem/clearAssetsAttachments",[]);
            this.$store.commit("masterItemAttachmentsStore/clearAssetAttachments",[]);
            this.$router.go(-1)
        },
        async deleteMasterItem() {
            // Initializing key variables
            const model = { ...this.model }
            const routes = {
                baseRoute: '/master-items',
                deleteRoute: 'masterItem/delete',
            }
            const notificationFields = {
                type: this.$translate('master_item'),
                errorMsg:
                    this.$translate('unable_master_item'),
            }
            // this.submitting = true;
            try {
                const result = await this.deleteItem(notificationFields, model, routes);
                if (result){
                    this.$emit('success');
                }
            } catch (error) {
                console.error(error);
                this.doToast(this.$translate('error'), this.$translate('unable_alert'), 'danger');
            } finally {
                this.submitting = false;
            }
        },
        async onSubmit() {
            try {
                const { assetAttachments: attachments } = this;
                console.log('attachments',attachments);
                const valid = await this.$validator.validate()
                if (!valid) {
                    throw new Error('Form not Validated!')
                }
                //check default valye
                const payload = { ...this.model,attachments }
                console.log('payload', payload)
                const {
                    is_selection_value_type,
                    default_value,
                    value_max,
                    value_min,
                } = payload
                if (
                    !is_selection_value_type &&
                    !(
                        default_value == null &&
                        value_max == null &&
                        value_min == null
                    )
                ) {
                    console.log('value- before', default_value)
                    const value = parseFloat(default_value)
                    console.log('value-', value)
                    if (isNaN(value)) {
                        throw new Error('Invalid Default Value')
                    }
                    const max = parseFloat(value_max)
                    console.log('max', max)
                    if (!isNaN(max) && value > max) {
                        throw new Error('Max Value')
                    }

                    const min = parseFloat(value_min)
                    console.log('min', min)
                    if (!isNaN(min) && value < min) {
                        throw new Error('Invalid Min Value')
                    }
                }

                payload.value_selections = JSON.stringify(
                    payload.value_selections
                )

                payload.default_value = payload.default_value
                    ? payload.default_value.toString()
                    : null

                const isEdit = !!parseInt(payload.id)
                const path = `masterItem/${isEdit ? 'update' : 'create'}`
                console.log('payload',payload);

                this.submitting = true
                let result = await this.$store.dispatch(path, payload)
                const action = isEdit ? this.$translate('updated') : this.$translate('created')
                const message = isEdit ? this.$translate('update_alert') : this.$translate('create_alert')
                if(!isEdit) {
                    await this.loadMasterItem(result.id)
                    this.$router.push(`/ams/master-items/${result.id}`)
                } else {
                    this.isView = true
                } 
                this.$emit('success', action, message)
                this.$router.go(-1)
            } catch (error) {
                this.genericToast(
                    this.componentName,
                    this.$translate('error'),
                    'danger',
                    `${error.message}`
                )
                // this.doToast('Error Detected', error.message, 'warning')
            } finally {
                this.submitting = false
            }
        },
    },
}
</script>
<style scoped>
    .ref_code{margin-top: -14px;}
    .is_selection_value_type{margin-top: 22px;}
    /* .value_selections{display: none;} */
</style>
